import { useMutation, useQueryClient } from '@tanstack/react-query';
import { startOffboard } from '../api/userManagementApi';
import { userKeys } from './userKeys';

export const useStartOffboard = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      userId,
      revokeAccess,
    }: {
      userId: string;
      revokeAccess: boolean;
    }) => startOffboard(userId, { revokeAccess }),

    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: userKeys.detail(variables.userId),
      });
      queryClient.invalidateQueries({ queryKey: userKeys.lists() });
    },
  });
};
